export const culture = {
    locale: "sk-SK",
    monthNames: ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December'],
    monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
    dayNames: ['Nedel\'a', 'Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'],
    dayNamesShort: ['Ned', 'Pon', 'Uto', 'Str', 'Štv', 'Pia', 'Sob'],
    dayNamesMin: ['Ne', 'Po', 'Ut', 'St', 'Št', 'Pia', 'So'],
    weekHeader: 'Ty',
    dateFormat: 'dd.mm.yy',
    datePlaceholder: 'dd.mm.yyyy',
    firstDay: 0,
    monthDayFormat: 'dd.mm',
    shortFormat: "d M",
    mediumFormat: "d M, y",
    mediumFullYearFormat: "d M, yy",
    monthShortFormat: "M yy",
    yearFormat: "yy",
    FullFormat: "dd M, yy",
    LongTimeFormat: 'H:mm:ss',
    shortTimeFormat: 'H:mm',
    decimalSeparator: ",",
    currencyDecimalSeparator: ',',
    currencyGroupSeparator: ' ',
    moneyWithCurrencyFormat: "{v} {c}",
    from: 'Od',
    by: 'Do',
    fromFormat: 'Od {0}',
    byFormat: 'Do {0}'
};

export const datepicker = {
    ...culture,
    closeText: 'Zavrieť',
    prevText: '&#x3c;Predchádzajúci',
    nextText: 'Nasledujúci&#x3e;',
    currentText: 'Dnes',
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: ''
};
